module.exports = __webpack_public_path__ + "static/media/salondragon-filler-1.80d26e8f.png";